var course = [
  {
    id: 0,
    name: "Web Design",
    image: "https://i.ibb.co/VpMGwVy/web-design.jpg",
    price: 70,
    mentor: "Naruto Uzumaki",
    duration: "60 Days",
    curriculam: [
      "HTML Introduction",
      "HTML Tags & Elements",
      "CSS Introduction",
      "CSS Properties",
      "JavaScript Basic",
      "Variable Types, Codition, Function, Loop",
      "Bootstrap",
      "Projects",
    ],
  },
  {
    id: 1,
    name: "Web Development (JS)",
    image: "https://i.ibb.co/hH0Yr5W/web-develop.jpg",
    price: 80,
    mentor: "Kakashi Hatake",
    duration: "90 Days",
    curriculam: [
      "JS Introduction",
      "JS Syntex and operators",
      "Variables, Variable Types, Object, Function",
      "Condition, Loop, Array",
      "NodeJS Introduction",
      "Node Structure",
      "DataBase",
      "Projects",
    ],
  },
  {
    id: 2,
    name: "Graphics Design",
    image: "https://i.ibb.co/hB9dfHb/graphic-design.jpg",
    price: 50,
    mentor: "Master Roshi",
    duration: "50 Days",
    curriculam: [
      "Graphics Introduction",
      "Software Installation",
      "Tools Introduction",
      "Layouts",
      "Design Concepts",
      "Skecting",
      "Banner, Logo, Card",
      "Projects",
    ],
  },
  {
    id: 3,
    name: "Search Engine Optimization (SEO)",
    image: "https://i.ibb.co/bzs8XGZ/seo.jpg",
    price: 55,
    mentor: "Lord Freeza",
    duration: "45 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 4,
    name: "Apps Development",
    image: "https://i.ibb.co/t8x0w2r/apps-develop.jpg",
    price: 100,
    mentor: "Goku",
    duration: "120 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 5,
    name: "Advance JavaScript",
    image: "https://i.ibb.co/2hrSF0w/Javascript.jpg",
    price: 85,
    mentor: "Vegita",
    duration: "70 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 6,
    name: "Content Development",
    image: "https://i.ibb.co/1LKZLw2/content.jpg",
    price: 40,
    mentor: "Hinata Shoyo",
    duration: "40 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 7,
    name: "Data Analysis",
    image: "https://i.ibb.co/hB2zxzL/data-analysis.jpg",
    price: 59,
    mentor: "Nara Shikamaru",
    duration: "55 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 8,
    name: "Digital Marketing",
    image: "https://i.ibb.co/19ysRJW/digital-marketing.jpg",
    price: 49,
    mentor: "Haruno Shakura",
    duration: "40 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 9,
    name: "Full Stack Web Development",
    image: "https://i.ibb.co/LYStvZp/full-stack.jpg",
    price: 99,
    mentor: "Uchia Sasuke",
    duration: "120 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },

  {
    id: 10,
    name: "Logo Design",
    image: "https://i.ibb.co/GFRMx8y/logo.jpg",
    price: 35,
    mentor: "Ino Yamanakchi",
    duration: "30 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 11,
    name: "Python Programming",
    image: "https://i.ibb.co/YW53mFR/python.jpg",
    price: 55,
    mentor: "Orochimaru",
    duration: "60 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 12,
    name: "Robotics",
    image: "https://i.ibb.co/1TT9VMd/robotics.jpg",
    price: 69,
    mentor: "Bulma",
    duration: "120 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 13,
    name: "UI/UX Designer",
    image: "https://i.ibb.co/CzPp0bH/ui-ux.jpg",
    price: 55,
    mentor: "Choji Akimiji",
    duration: "90 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
  {
    id: 14,
    name: "Wordpress development",
    image: "https://i.ibb.co/XJDSzdq/wordpress.jpg",
    price: 39,
    mentor: "Tsunade",
    duration: "55 Days",
    curriculam: [
      "Course Introduction",
      "Software Installation",
      "Tools Introduction",
      "Step Understanding",
      "Concepts Gather",
      "Skecting / Simplified",
      "Deployment Proccess",
      "Projects",
    ],
  },
];

export default course;
